import { Box, Button, Grid, Typography } from '@mui/material';
import apiManagerRoom from 'api/manager-meeting';
import { ReactComponent as IconCopy } from 'assets/icons/IconCopy.svg';
import { BreadcrumbsCC, ContainerPage } from 'components/Layout';
import { SearchCC } from 'components/common/SearchCC';
import { PATH_ROOT } from 'constants/api';
import moment from 'moment';
import { setStateModalDetail } from 'pages/manager-meeting/modelPeriodSlice';
import { ROLE, RenderEmailOrNameUserDisplayDetail } from 'pages/subtitles/components/constants';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { setCloseModal } from 'store/modal/modalSlice';
import theme, { color } from 'theme';
import { getUserProperty, toastError, toastSuccess, toastWarning } from 'utils/helpers';
import { ActionButton } from './ActionButton';
import { AdvancedSettings } from './AdvancedSetting';
import DialogLimitTotalMeeting from './DialogLimitTotalMeeting';
import DialogLimitTotalMeetingHost from './DialogLimitTotalMeetingHost';
import ItemFile from './ItemFile';
import { useResponsivePixel } from './useResponsivePixel';
import ItemMeetingInfo from './ItemMeetingInfo';
import { AvatarUser } from 'components/common';
import { USER_PROPERTIES } from 'constants/user';

const MeetingDetails = () => {
    //CONSTANST, STATE AT HERE!!!
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { roomIdByURL } = useParams();
    const userName = getUserProperty(USER_PROPERTIES.USERNAME);
    const [meetingCurrent, setMeetingCurrent] = useState();
    const [realTotalParticipant, setRealTotalParticipant] = useState(0);
    const [startEndTime, setStartEndTime] = useState();
    const [hostRoomIsOwner, setHostRoomIsOwner] = useState(false);
    const [dataFiles, setDataFiles] = useState([]);
    const [inviteeStatus, setInviteStatus] = useState(null);
    const [stateInvite, setStateInvite] = useState(null);
    const [searchUser, setSearchUser] = useState('');
    const startTimeRoom = localStorage.getItem('StartTimeRoom');
    const [inviteState, setInviteState] = useState('');
    const { smPixel, mdPixel } = useResponsivePixel();

    //FUNCTION AT HERE!!!
    const handleSearchUser = (emptyUser = false) => {
        if (emptyUser) {
            setMeetingCurrent((prev) => ({
                ...prev,
                participantRender: meetingCurrent.participant,
            }));
        } else {
            setMeetingCurrent((prev) => ({
                ...prev,
                participantRender:
                    searchUser?.length > 0
                        ? meetingCurrent.participant.filter(
                              (user) =>
                                  user.name.toLowerCase().includes(searchUser) ||
                                  user.email.toLowerCase().includes(searchUser),
                          )
                        : meetingCurrent.participant,
            }));
        }
    };

    const convertRole = (role) => {
        if (role === ROLE.HOST) {
            return t('modalDetail.roleUser.host');
        } else if (role === ROLE.OWNER) {
            return t('modalDetail.roleUser.owner');
        } else if (role === ROLE.CO_HOST) {
            return t('modalDetail.roleUser.coHost');
        } else {
            return t('modalDetail.roleUser.participant');
        }
    };

    const getFiles = (roomId) => {
        return apiManagerRoom.getFiles(roomId);
    };
    const getRoom = (data, startTimeRoom = false) => {
        if (startTimeRoom) {
            return apiManagerRoom.getRoom(data, startTimeRoom);
        } else return apiManagerRoom.getRoom(data);
    };

    const setData = () => {};

    const actionCloseModal = (_) => {
        dispatch(setCloseModal());
    };

    const handleAccept = async () => {
        // setInviteStatus(1);
        await accept({
            roomId: meetingCurrent?.parentRoomId || meetingCurrent?.roomId,
            inviteeStatus: 1,
            message: null,
        })
            .then((r) => {
                if (r.status === 200) {
                    setInviteStatus(1);
                    toastSuccess(t('toast.acceptMeetSuccess'));
                    actionCloseModal();
                    // props?.setReload(moment())
                } else {
                    toastError(t('toast.errorServer'));
                    // props?.setReload(moment())
                }
            })
            .catch((e) => {
                console.log(e);
            });

        setInviteState('accept');
    };

    const handleReject = async (message, roomId) => {
        setInviteState('reject');
    };

    const copyToClipboard = (e, t) => {
        navigator.clipboard.writeText(e);
        toastSuccess(t('toast.copied'));
    };

    const convertStatusMeetingToString = (type) => {
        switch (type) {
            case 'not_start':
                if (meetingCurrent?.isTrash === 0 && moment(meetingCurrent?.end).diff(moment(), 'minutes') >= 0) {
                    return (
                        <span style={{ textAlign: 'end', color: '#000000', fontWeight: '700' }}>
                            {t('meeting.type.not_start')}
                        </span>
                    );
                } else if (
                    meetingCurrent?.isTrash === 1 &&
                    moment(meetingCurrent?.end).diff(moment(), 'minutes') >= 0
                ) {
                    return (
                        <span style={{ textAlign: 'end', color: '#000000', fontWeight: '700' }}>
                            {t('meeting.type.trash')}
                        </span>
                    );
                } else if (meetingCurrent?.isTrash === 1 && moment(meetingCurrent?.end).diff(moment(), 'minutes') < 0) {
                    return (
                        <span style={{ textAlign: 'end', color: '#000000', fontWeight: '700' }}>
                            {t('meeting.type.trash')}
                        </span>
                    );
                } else {
                    return (
                        <span style={{ textAlign: 'end', color: '#000000', fontWeight: '700' }}>
                            {t('meeting.type.over')}
                        </span>
                    );
                }
            case 'progress':
                return (
                    <span style={{ textAlign: 'end', color: 'rgb(0, 76, 137)', fontWeight: '700' }}>
                        {t('meeting.type.process')}
                    </span>
                );
            case 'end':
                return (
                    <span style={{ textAlign: 'end', color: 'rgb(0, 130, 21)', fontWeight: '700' }}>
                        {t('meeting.type.end')}
                    </span>
                );
            default:
                return false;
        }
    };

    const convertStatusInvite = (user) => {
        let str = '';
        if (user.role === ROLE.OWNER) {
            return '';
        }

        if (user.inviteeStatus === 1) {
            str = t('modalDetail.access');
            return <span style={{ color: color.greenF02 }}>{str.charAt(0).toUpperCase() + str.slice(1)}</span>;
        } else if (user.inviteeStatus === 0) {
            str = t('modalDetail.decline');
            return <span style={{ color: color.redP01 }}>{str.charAt(0).toUpperCase() + str.slice(1)}</span>;
        } else {
            str = t('modalDetail.waiting');
            return <span>{str.charAt(0).toUpperCase() + str.slice(1)}</span>;
        }
    };

    //API AT HERE!!!
    const deleteRoom = (data) => {
        return apiManagerRoom.deleteRoom(data);
    };

    const stateInviteInviteStatus = (data) => {
        return apiManagerRoom.info_inviteeStatus(data);
    };

    const cancelRoom = (data) => {
        return apiManagerRoom.cancelRoom(data);
    };

    const accept = (data) => {
        return apiManagerRoom.statusMeeting(data);
    };

    const restoreRoom = (params) => {
        return apiManagerRoom.restoreRoom(params);
    };

    const getDetailStatisticsRoom = (roomId, currentPage, startTimeRoom = false) => {
        if (Boolean(startTimeRoom) && startTimeRoom !== 'null' && startTimeRoom !== null) {
            return apiManagerRoom.getDetailStatisticsRoom(roomId, currentPage, startTimeRoom, true);
        } else return apiManagerRoom.getDetailStatisticsRoom(roomId, currentPage, false, true);
    };

    //USE_EFFECT AT HERE!!!
    useEffect(() => {
        getRoom(roomIdByURL, startTimeRoom)
            .then(async (r) => {
                if (r.status === 200) {
                    setMeetingCurrent({
                        ...r.data[0],
                        participantRender: r.data[0].participant,
                        advancedSettings: {
                            camera: r.data[0].camera_permission,
                            micro: r.data[0].micro_permission,
                            message: r.data[0].message_permission_group,
                            sharingFile: r.data[0].sharing_file_permission,
                            pollPermission: r.data[0].poll_permission,
                            meetingMode: r.data[0].meeting_mode,
                            sharingScreenPermission: r.data[0].sharing_screen_permission,
                            whiteboardPermission: r.data[0].white_board_permission,
                            handUpPermission: r.data[0].hand_up_permission,
                            changeNamePermission: r.data[0].change_name_permission,
                            recordPermission: r.data[0].record_permission,
                            noticeTimeEndRoom: r.data[0].notice_time_end_room,
                        },
                        start: moment.unix(r.data[0].tsStart),
                        end: moment.unix(r.data[0].tsEnd),
                        tsStart: moment.unix(r.data[0].tsStart),
                        tsEnd: moment.unix(r.data[0].tsEnd),
                    });

                    //filter role coHost and particpant
                    let participants = r.data[0]?.participant;

                    stateInviteInviteStatus(r.data[0].parentRoomId || r.data[0].roomId)
                        .then((res) => {
                            if (res.status === 200) {
                                setInviteStatus(res.data[0].inviteeStatus);
                                setStateInvite(res.data[0]);
                            }
                        })
                        .catch((err) => console.log('ERROR: ', err));

                    //set HostRoom and OwnerRoom
                    let findHostRoom = participants?.find((participant) => participant.role === 'host');
                    if (findHostRoom) {
                        setHostRoomIsOwner(false);
                    } else {
                        setHostRoomIsOwner(true);
                    }

                    //get File
                    await getFiles(r.data[0].parentRoomId || r.data[0].roomId)
                        .then((res) => {
                            if (res.status === 200) {
                                if (res.data === 'NO_ROOM_OR_NO_PERMISSION') {
                                    setDataFiles([]);
                                } else {
                                    setDataFiles(res.data);
                                }
                            } else {
                                console.log('ERROR: ', res);
                            }
                        })
                        .catch((err) => console.log('===> ERROR: ', err));

                    //get totalParticipant
                    if (r.data[0].type === 'end') {
                        setStartEndTime({
                            startTime: r.data[0]?.startRealTime,
                            endTime: r.data[0]?.endRealTime,
                        });

                        getDetailStatisticsRoom(r.data[0].parentRoomId || r.data[0].roomId, 0, startTimeRoom)
                            .then((response) => {
                                setRealTotalParticipant(response.realTotalParticipants);
                            })
                            .catch((error) => {
                                console.log('ERR: ', error);
                            });
                    }
                }
            })
            .catch((e) => {
                if (
                    e.response.data.data === 'PERMISSION_DENIED' ||
                    e.response.data.data === 'ROOM_NOT_EXISTED_OR_PERMISSION_DENIED'
                ) {
                    toastWarning(t('meeting.permissionDenied'));
                    navigate(`${PATH_ROOT}/manager-meeting`);
                }
            });

        return () => {
            dispatch(setStateModalDetail({ isOpenModalDetail: false }));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inviteState, roomIdByURL]);

    return (
        <React.Fragment>
            <ContainerPage sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <DialogLimitTotalMeetingHost />
                <DialogLimitTotalMeeting />
                <BreadcrumbsCC>
                    <ActionButton
                        t={t}
                        navigate={navigate}
                        stateInvite={stateInvite}
                        meetingCurrent={meetingCurrent}
                        handleReject={handleReject}
                        inviteeStatus={inviteeStatus}
                        handleAccept={handleAccept}
                        userName={userName}
                        restoreRoom={restoreRoom}
                        cancelRoom={cancelRoom}
                        deleteRoom={deleteRoom}
                        getRoom={getRoom}
                        roomIdByURL={roomIdByURL}
                        startTimeRoom={startTimeRoom}
                    />
                </BreadcrumbsCC>
                {/* <InfoMeetingCC /> */}
                <Box sx={{ flexGrow: '1' }}>
                    <Grid
                        container
                        columnSpacing={smPixel ? 5 : 1}
                        rowSpacing={2}
                        sx={{
                            marginLeft: 0,
                            borderTop: `1px solid ${color.greyIL06}`,
                            borderBottom: `1px solid ${color.greyIL06}`,
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <Grid
                            item
                            xs={12}
                            md={8}
                            lg={9}
                            sx={{ padding: '30px 0', borderBottom: `1px solid ${color.greyIL06}` }}
                        >
                            <Box
                                sx={{
                                    py: 2,
                                    borderBottom: `1px solid ${color.greyIL06}`,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    rowGap: 2,
                                }}
                            >
                                <Grid container>
                                    <Grid
                                        item
                                        xs={12}
                                        md={3}
                                        lg={3}
                                        xl={2.5}
                                        sx={{ textAlign: 'end', paddingRight: '24px' }}
                                    >
                                        <Typography fontWeight={550} sx={{ color: (theme) => theme.palette.text[700] }}>
                                            {t('meeting.roomName')}
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        md={9}
                                        lg={9}
                                        xl={9.5}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            fontWeight: '500',
                                        }}
                                    >
                                        <Grid container>
                                            <Grid item xs={8}>
                                                <Typography fontWeight={600}>{meetingCurrent?.roomName}</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Typography ml={1} display={'flex'}>
                                                    {t('meeting.status')}:
                                                    <Typography fontWeight={600} ml={0.5}>
                                                        {convertStatusMeetingToString(meetingCurrent?.type)}
                                                    </Typography>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <ItemMeetingInfo
                                    labelKey={'meeting.description'}
                                    content={meetingCurrent?.description}
                                />
                                <ItemMeetingInfo
                                    labelKey={'meeting.time-expected'}
                                    content={
                                        meetingCurrent?.isInstant !== 1
                                            ? moment(meetingCurrent?.tsStart).format('DD/MM/YYYY HH:mm') +
                                              ' - ' +
                                              moment(meetingCurrent?.tsEnd).format('DD/MM/YYYY HH:mm')
                                            : '---'
                                    }
                                />
                                <ItemMeetingInfo
                                    labelKey={'meeting.time-real'}
                                    content={
                                        startEndTime?.startTime && startEndTime?.endTime
                                            ? `${moment
                                                  .unix(startEndTime?.startTime)
                                                  .format('DD/MM/YYYY HH:mm')} - ${moment
                                                  .unix(startEndTime?.endTime)
                                                  .format('DD/MM/YYYY HH:mm')}`
                                            : `---`
                                    }
                                />
                                <ItemMeetingInfo
                                    labelKey={'meeting.number-participants'}
                                    content={meetingCurrent?.type === 'end' ? realTotalParticipant : `---`}
                                />
                                <ItemMeetingInfo
                                    labelKey={'room.room-mode.title'}
                                    content={
                                        meetingCurrent?.meeting_mode === 0
                                            ? t('room.room-mode.normal')
                                            : t('room.room-mode.private')
                                    }
                                />
                                <ItemMeetingInfo
                                    labelKey={'room.attachedFile'}
                                    content={false}
                                    customComponent={
                                        dataFiles &&
                                        dataFiles?.length > 0 && (
                                            <div className="flex">
                                                <div
                                                    id="containerFiles"
                                                    style={{
                                                        flexWrap: 'wrap',
                                                        maxHeight: 98,
                                                        overflowY: 'auto',
                                                        display: 'flex',
                                                        paddingLeft: '10px',
                                                    }}
                                                >
                                                    {dataFiles?.map((file, index) => (
                                                        <ItemFile
                                                            key={index}
                                                            roomId={
                                                                (meetingCurrent?.parentRoomId &&
                                                                    meetingCurrent?.parentRoomId) ||
                                                                (meetingCurrent?.roomId && meetingCurrent?.roomId)
                                                            }
                                                            file={file}
                                                            isFirst={index === 0}
                                                            isDownload={true}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        )
                                    }
                                />
                            </Box>

                            <Box
                                sx={{
                                    py: 2,
                                    borderBottom: `1px solid ${color.greyIL06}`,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    rowGap: 2,
                                }}
                            >
                                <ItemMeetingInfo
                                    labelKey={'room.link'}
                                    content={meetingCurrent?.link}
                                    isCenter={true}
                                    isLink={true}
                                    customComponent={
                                        <Button
                                            sx={{
                                                color: theme.palette.primary.main,
                                                borderColor: theme.palette.primary.main,
                                                margin: { xs: '5px 0 0 0', lg: '0 0 0 30px' },
                                            }}
                                            variant="outlined"
                                            onClick={(e) => {
                                                copyToClipboard(meetingCurrent?.link, t);
                                            }}
                                            size="large"
                                            startIcon={<IconCopy style={{ marginTop: 2 }} width={24} height={24} />}
                                        >
                                            {t('actions.btnCopyRoom')}
                                        </Button>
                                    }
                                />
                                <ItemMeetingInfo
                                    labelKey={'meeting.idMeeting'}
                                    content={
                                        (meetingCurrent?.parentRoomId && meetingCurrent?.parentRoomId) ||
                                        (meetingCurrent?.roomId && meetingCurrent?.roomId)
                                    }
                                />

                                <ItemMeetingInfo
                                    labelKey={'room.password'}
                                    content={meetingCurrent?.password ? meetingCurrent.password : '---'}
                                />
                                <ItemMeetingInfo
                                    labelKey={'room.waiting-room'}
                                    content={meetingCurrent?.lobby === 1 ? t('room.have') : t('room.not')}
                                />
                            </Box>

                            <Box sx={{ py: 2 }}>
                                <ItemMeetingInfo
                                    labelKey={'room.setUp'}
                                    content={''}
                                    customComponent={
                                        <Box flex={1}>
                                            <AdvancedSettings
                                                data={meetingCurrent?.advancedSettings}
                                                setData={setData}
                                                pageDetail={true}
                                            />
                                        </Box>
                                    }
                                />
                            </Box>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={4}
                            lg={3}
                            sx={{
                                borderLeft: `1px solid ${color.greyIL06}`,
                                borderTop: mdPixel ? '' : `1px solid ${color.greyIL06}`,
                                paddingRight: '40px',
                            }}
                        >
                            <Box sx={{ height: '100%' }}>
                                <Box sx={{ marginBottom: '25px' }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            paddingTop: '24px',
                                            paddingBottom: '16px',
                                        }}
                                    >
                                        <Typography fontWeight={700} sx={{ fontSize: { md: '20px' } }}>
                                            {t('modalDetail.inviter-detail')}:{' '}
                                            {`${
                                                hostRoomIsOwner
                                                    ? meetingCurrent?.totalCoHostAndInviter + 1
                                                    : meetingCurrent?.totalCoHostAndInviter +
                                                          meetingCurrent?.totalHostNotOwner +
                                                          1 || ''
                                            }`}
                                        </Typography>

                                        <Typography
                                            fontSize={15}
                                            fontStyle={'italic'}
                                            color={(theme) => theme.palette.text[700]}
                                        >
                                            (
                                            {hostRoomIsOwner
                                                ? meetingCurrent?.totalAccess
                                                : meetingCurrent?.totalAccess}{' '}
                                            {t('modalDetail.access')}, {meetingCurrent?.totalDecline}{' '}
                                            {t('modalDetail.decline')}, {meetingCurrent?.totalWaiting}{' '}
                                            {t('modalDetail.waiting')})
                                        </Typography>
                                    </Box>
                                    <SearchCC
                                        marginLeft=""
                                        value={searchUser}
                                        setValue={setSearchUser}
                                        handleValue={handleSearchUser}
                                        placeholder={t('room.placeholder.searchUser')}
                                    />
                                </Box>
                                <Box>
                                    {meetingCurrent?.participantRender?.map((user, index) => {
                                        return (
                                            <Box
                                                sx={{
                                                    position: 'relative',
                                                    minHeight: '40px',
                                                    padding: '12.5px 0 9.5px',
                                                    borderBottom: `1px solid ${color.greyIL05}`,
                                                    borderBottomStyle: 'dashed',
                                                    borderTop: index === 0 ? `1px solid ${color.greyIL05}` : 'none',
                                                    borderTopStyle: index === 0 ? 'dashed' : 'none',
                                                    display: 'flex'
                                                }}
                                            >
                                                <AvatarUser user={user} />
                                                <Box ml={1}>
                                                    <RenderEmailOrNameUserDisplayDetail
                                                        name={user?.name}
                                                        email={user?.email}
                                                    />
                                                    <Typography
                                                        sx={{
                                                            fontSize: '12px',
                                                            color: (theme) => theme.palette.text[700],
                                                        }}
                                                    >
                                                        {convertRole(user?.role || user?.participantType)}{' '}
                                                        {user?.role !== ROLE.OWNER && (
                                                            <span style={{ padding: '0 5px' }}>|</span>
                                                        )}{' '}
                                                        {convertStatusInvite(user)}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        );
                                    })}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </ContainerPage>
        </React.Fragment>
    );
};

export default MeetingDetails;
